import React from 'react';

import styled from 'styled-components';

const StyledIconBackground = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  width: 48px;
  height: 48px;
  border-radius: 16px;

  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || 'transparent'};
`;

interface ColorIconProps {
  icon: React.ReactNode;
  backgroundColor?: string;
}

export const ColorIcon: React.FC<ColorIconProps> = ({
  icon,
  backgroundColor,
}) => (
  <StyledIconBackground
    data-testid="colorIcon"
    $backgroundColor={backgroundColor}
  >
    {icon}
  </StyledIconBackground>
);
